import { Payment } from './payment';

export default Payment;
